module.exports = __webpack_public_path__ + "img/itx-text-underline.5034703f.svg";